"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PROJECT_AUDIT_LOG = exports.CREATE_PROJECT_AUDIT_LOG = exports.LIST_PROJECT_AUDIT_LOG = void 0;
const route_1 = require("./route");
const list_1 = __importDefault(require("./list"));
const edit_1 = __importDefault(require("./edit"));
exports.LIST_PROJECT_AUDIT_LOG = route_1.PROJECT_AUDIT_LOGS.sub("", list_1.default);
exports.CREATE_PROJECT_AUDIT_LOG = route_1.PROJECT_AUDIT_LOGS.sub("/new", edit_1.default);
exports.UPDATE_PROJECT_AUDIT_LOG = route_1.PROJECT_AUDIT_LOG.sub("", edit_1.default);
